function EvaluationListRow({
  nombre,
  legajo,
  examen,
  isSelected = false,
  onClick,
}) {
  return (
    <button
      type="button"
      onClick={onClick}
      className={`grid w-full grid-cols-[1.5fr_1fr_1fr] items-start gap-3 border border-[#dce2e8] px-3 py-3 text-left transition ${
        isSelected ? 'bg-[#d8f0db]' : 'bg-white hover:bg-[#f7fafc]'
      }`}
    >
      <span className="font-login text-[11px] font-bold uppercase leading-[1.35] text-[#5f6673] sm:text-[12px]">
        {nombre}
      </span>
      <span className="font-login text-[11px] font-semibold uppercase leading-[1.35] text-[#4b5563] sm:text-[12px]">
        {legajo}
      </span>
      <span className="font-login text-[11px] font-semibold uppercase leading-[1.35] text-[#4b5563] sm:text-[12px]">
        {examen}
      </span>
    </button>
  );
}

export default EvaluationListRow;
